import {
  Box,
  Button,
  Chip,
  Card,
  Divider,
  Drawer,
  IconButton,
  Typography,
  Tooltip,
  Menu,
  MenuItem,
} from "@mui/material";
import SecScoreGood from "../assets/baseVersion/SecScoreGood.svg";
import CancelIcon from "@mui/icons-material/Cancel";
import SecScoreLow from "../assets/baseVersion/SecScoreLow.svg";
import SecScoreAverage from "../assets/baseVersion/SecScoreAvg.svg";
import InfoIcon from "@mui/icons-material/Info";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import React, { useEffect, useState } from "react";
import axiosInstance from "../services/axiosInstance";
import { SA_ORGANIZATIONS_LIST } from "../shared/constants/apiEndpoints";
import AgGridTable from "../components/table/AgGridTable";
import InviteOrgTableDrawer from "../components/drawer/InviteOrgTableDrawer";
import InviteOrgDrawer from "../components/drawer/InviteOrgDrawer";
import CloseIcon from "@mui/icons-material/Close"; // Ensure this is installed
import NoData_img1 from "../assets/baseVersion/Nodata.svg";
import axios from "axios";
import { toast } from "react-toastify";
import SkeletonLoader from "../components/skeleton_loader";

const parseDateValue = (value?: string | null) => {
  if (!value) return 0;

  const timestamp = Date.parse(value);
  if (!Number.isNaN(timestamp)) return timestamp;

  const parts = value.split(/[-/]/);
  if (parts.length === 3) {
    const [day, month, year] = parts;
    const reconstructed = `${year}-${month}-${day}`;
    const reconstructedTimestamp = Date.parse(reconstructed);
    if (!Number.isNaN(reconstructedTimestamp)) {
      return reconstructedTimestamp;
    }
  }

  return 0;
};

const Organisation = () => {
  const [isTableRowClick, setIsTableRowClick] = useState(false);
  const [orgData, setOrgData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [isSelectedRow, setIsSelectedRow] = useState<any>(null);
  const [tableData, setTableData] = useState<any[]>([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const isDarkMode = false;

  const InviteTable = () => {
    // setOrgData([{
    //         "id": "1823e7d8-c3a3-4c6e-a426-8789a9bd5ca9",
    //         "org_name": "nageswar441test3",
    //         "onboard_by": "System",
    //         "email": "nageswar441+test3@gmail.com",
    //         "status": "Deactivated",
    //         "subscription": "Unknown",
    //         "licence_updated_on": "29 Feb 2024",
    //         "expiry_date": "13 Mar 2025",
    //         "scaned_assets": 0,
    //         "scaned_resources": 0,
    //         "security_score": 0,
    //         "users": 1,
    //         "onboarding_date": "16 Jan 2024",
    //         "_intelli_score": 0.0,
    //         "_actual_score": 0.0,
    //         "_cve_score": 0
    //     }])
    setLoading(true);
    axiosInstance
      .get(SA_ORGANIZATIONS_LIST)
      .then((res) => {
        const organizationsData = res.data?.data || res.data;

        const transformedData =
          organizationsData?.map((org: any) => ({
            org_name: org.org_name || org.organization_name,
            onboard_by: org.onboarded_by,
            email: org.admin_email || org.organization_email || "",
            status: org.status,
            subscription: org.subscription,
            licence_updated_on: org.license_updated_on,
            scaned_assets: org.scanned_assets,
            scaned_resources: org.scanned_resources,
            // security_score: org.security_score,
            users: org.user_count,
            id: org.org_id || org.id,
            expiry_date: org.expiry_date,
            onboarding_date: org.onboarding_date,
          })) || [];
        setTableData(organizationsData);
        setOrgData(transformedData);
      })
      .catch((err) => {
        console.error("Error fetching organizations:", err);
        setOrgData([]);
      })
      .finally(() => setLoading(false));
  };
  const inviteTablerefetch = () => {
    console.log("refetching table data");
    InviteTable();
  };
  useEffect(() => {
    InviteTable();
  }, []);

  // }, []);

  const handleRefreshOrg = () => {
    axiosInstance.get(SA_ORGANIZATIONS_LIST).then(() => {});
  };

  const handleReportButtonClick = async () => {
    console.log("Download report button clicked");
    try {
      const response = await axiosInstance.get(
        "/authentication/super-admin/organizations/export",
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "organizations_report.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Report downloaded successfully");
    } catch (error) {
      toast.error("Failed to download report");
      console.error("Download report error:", error);
    }
  };

  const handleOnRowClick = (row: any) => {
    setIsTableRowClick(true);
    setIsSelectedRow(row.id);
  };

  const KebabMenuCellRenderer = (props: any) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleView = () => {
      handleClose();
      setIsTableRowClick(true);
      setIsSelectedRow(props.data.id);
    };

    const handleReInvite = async () => {
      handleClose();
      try {
        const response = await axiosInstance.post(
          `/authentication/sa-org-reinvite`,
          {
            org_id: props.data.id,
          }
        );
        toast.success(response?.data?.message || "Organization reinvited successfully");
        InviteTable(); // Refresh the table data
      } catch (error: any) {
        console.error("Error reinviting organization:", error);
        toast.error(error?.response?.data?.message || "Failed to reinvite organization");
      }
    };

    const handleDeactivate = async () => {
      handleClose();
      try {
        const response = await axiosInstance.post(
          `/authentication/sa-organizations/${props.data.id}/deactivate`
        );
        toast.success(response?.data?.message || "Organization deactivated successfully");
        InviteTable(); // Refresh the table data
      } catch (error: any) {
        console.error("Error deactivating organization:", error);
        toast.error(error?.response?.data?.message || "Failed to deactivate organization");
      }
    };

    const handleReActiveLicense = async () => {
      handleClose();
      try {
        const response = await axiosInstance.post(
          `/authentication/sa-organizations/${props.data.id}/activate`
        );
        toast.success(response?.data?.message || "License activated successfully");
        InviteTable(); // Refresh the table data
      } catch (error: any) {
        console.error("Error activating license:", error);
        toast.error(error?.response?.data?.message || "Failed to activate license");
      }
    };

    return (
     <>
  <IconButton size="small" onClick={handleClick}>
    <MoreVertIcon fontSize="small" />
  </IconButton>

  <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
    {/* Always show Update License */}
    <MenuItem onClick={handleView}>Update License</MenuItem>

    {/* Status-based options */}
    {props.data.status === "Active" && (
      <MenuItem onClick={handleDeactivate}>Deactivate</MenuItem>
    )}

    {props.data.status === "Deactivated" && (
      <MenuItem onClick={handleReActiveLicense}>Re-Activate License</MenuItem>
    )}

    {(props.data.status === "Invited" || props.data.status === "Invite Expired") && (
      <MenuItem onClick={handleReInvite}>Re-Invite</MenuItem>
    )}
  </Menu>
</>
    );
  };

  return (
    <>
      {loading ? (
        <Box
          sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* <Typography variant="h6">Loading...</Typography> */}
          <SkeletonLoader
            count={Math.floor(window.innerHeight / 40)}
            styles={{ height: 30, width: "100%" }}
          />{" "}
          {/* Replace this with <CircularProgress /> if using MUI Spinner */}
        </Box>
      ) : tableData?.length > 0 ? (
        <Box sx={{ width: "100%", height: "100%" }}>
          <Card
            variant="outlined"
            sx={{
              height: "calc(100vh - 103px)",
              borderRadius: 3,
              width: "100%",
            }}
          >
            <AgGridTable
              columnDefs={[
                {
                  headerName: "Org Name",
                  field: "org_name",
                  minWidth: 150,
                  cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  },
                  cellRenderer: (params: any) => {
                    return (
                      <Tooltip
                        title={params.value || ""}
                        arrow
                        slotProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#fff",
                              color: "#000",
                              fontSize: "14px",
                              boxShadow: 2,
                            },
                          },
                          arrow: {
                            sx: {
                              color: "#fff",
                            },
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "pointer",
                          }}
                        >
                          {params.value}
                        </Typography>
                      </Tooltip>
                    );
                  },
                },
                {
                  headerName: "Onboarded by",
                  minWidth: 150,
                  field: "onboard_by",
                  cellStyle: { fontWeight: "bold" },
                },

                {
                  headerName: "Email",
                  field: "email",
                  minWidth: 230,
                  cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  },
                  cellRenderer: (params: any) => {
                    return (
                      <Tooltip
                        title={params.value || ""}
                        arrow
                        slotProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#fff",
                              color: "#000",
                              fontSize: "14px",
                              boxShadow: 2,
                            },
                          },
                          arrow: {
                            sx: {
                              color: "#fff",
                            },
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "pointer",
                          }}
                        >
                          {params.value}
                        </Typography>
                      </Tooltip>
                    );
                  },
                },
                {
                  headerName: "Status",
                  field: "status",
                  minWidth: 250,
                  cellRenderer: (params: any) => {
                    const expiryTimestamp = parseDateValue(
                      params?.data?.expiry_date
                    );
                    const now = Date.now();
                    const isSubscriptionExpired =
                      expiryTimestamp > 0 && now > expiryTimestamp;
                    const label = isSubscriptionExpired
                      ? "Subscription Expired"
                      : params.value === "Deactivated"
                        ? "Deactivated"
                        : params.value;

                    return (
                      <Chip
                        label={label}
                        size="small"
                        variant="outlined"
                        sx={{
                          fontWeight: "bold",
                          fontSize: "13px",
                          borderRadius: "6px",
                          px: 1.5,
                          py: 0.5,
                          textTransform: "capitalize",
                          borderWidth: "1.5px",

                          ...(params.value === "Active" && !isSubscriptionExpired && {
                            color: "#00A61B",
                            borderColor: "#00A61B",
                            backgroundColor: "#00A61B1A",
                          }),

                          ...(params.value === "Deactivated" && !isSubscriptionExpired && {
                            color: "#7C79A3",
                            borderColor: "#7C79A3",
                            backgroundColor: "#7C79A31A",
                          }),

                          ...(isSubscriptionExpired && {
                            color: "#FF3B3B",
                            borderColor: "#FF3B3B",
                            backgroundColor: "#FF3B3B1A",
                          }),

                          ...(params.value !== "Active" &&
                            params.value !== "Deactivated" &&
                            !isSubscriptionExpired && {
                              color: "#FF3B3B",
                              borderColor: "#FF3B3B",
                              backgroundColor: "#FF3B3B1A",
                            }),

                          ...(params.value === "Invited" && !isSubscriptionExpired && {
                            color: "black",
                            borderColor: "black",
                            backgroundColor: "white",
                          }),
                        }}
                      />
                    );
                  },
                },
                {
                  headerName: "Subscription",
                  field: "subscription",
                  minWidth: 150,
                  cellStyle: { fontWeight: "bold" },
                },
                {
                  headerName: "Expiry Date",
                  minWidth: 150,
                  field: "expiry_date",
                  cellStyle: { fontWeight: "bold" },
                  comparator: (valueA: string, valueB: string) =>
                    parseDateValue(valueA) - parseDateValue(valueB),
                },
                {
                  headerName: "Scanned Assets",
                  minWidth: 150,
                  field: "scaned_assets",
                  cellStyle: { fontWeight: "bold" },
                },
                {
                  headerName: "Scanned Resources",
                  minWidth: 170,
                  field: "scaned_resources",
                  cellStyle: { fontWeight: "bold" },
                },
                // {
                //   headerName: "Security Score",
                //   field: "security_score",
                //   cellRenderer: (params: any) => {
                //     const score = Number(params.value);
                //     let imgSrc = SecScoreLow;
                //     let alt = "Low";
                //     if (score > 80) {
                //       imgSrc = SecScoreGood;
                //       alt = "Good";
                //     } else if (score > 40) {
                //       imgSrc = SecScoreAverage;
                //       alt = "Average";
                //     }
                //     return (
                //       <Box display="flex" alignItems="center" gap={1}>
                //         <img src={imgSrc} alt={alt} style={{ width: 24, height: 24 }} />
                //         <span>{score}</span>
                //       </Box>
                //     );
                //   },
                // },
                {
                  headerName: "Users",
                  minWidth: 100,
                  field: "users",
                  cellStyle: { fontWeight: "bold" },
                },
                {
                  headerName: "",
                  field: "actions",
                  minWidth: 70,
                  maxWidth: 70,
                  sortable: false,
                  filter: false,
                  cellStyle: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                  cellRenderer: KebabMenuCellRenderer,
                },
              ]}
              data={orgData}
              showSearch
              isRowSelectable
              height={"calc(88vh - 90px)"}
              onRowClick={handleOnRowClick}
              isLoading={loading}
              handleReportButtonClick={handleReportButtonClick}
              InviteTableRefresh={InviteTable}
              onInviteSuccess={handleRefreshOrg}
              // isReportLoading={isReportLoading}
            />
            <Drawer
              anchor="right"
              open={isTableRowClick}
              onClose={() => {
                setIsTableRowClick(false);
                InviteTable();
              }}
              sx={{
                "& .MuiDrawer-paper": {
                  width: "45%",
                  p: 1,
                  overflow: "auto",
                  scrollbarWidth: "thin",
                },
              }}
            >
              <InviteOrgTableDrawer
                setIsTableRowClick={setIsTableRowClick}
                isSelectedRow={isSelectedRow}
                onOrgUpdate={InviteTable}
              />
            </Drawer>
          </Card>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "100vh",
            width: "100vw",
            position: "fixed",
            top: 0,
            left: 0,
            bgcolor: "background.default",
          }}
        >
          <img
            src={NoData_img1}
            alt="No Data"
            style={{ width: 300, marginBottom: 16 }}
          />
          <Typography variant="h5" sx={{ fontWeight: "bold", mt: 2, mb: 1 }}>
            Welcome to Spark Super Admin!
          </Typography>
          <Typography
            variant="body2"
            align="center"
            sx={{
              fontSize: "13px",
              mb: 3,
              color: isDarkMode ? "white" : "gray600",
              fontWeight: 600,
            }}
          >
            Let’s get started by inviting your first organization by
            <br />
            clicking the button below.
          </Typography>
          <Button
            variant="contained"
            style={{ padding: "8px" }}
            onClick={() => setIsDrawerOpen(true)}
          >
            Invite Organization
          </Button>

          <Drawer
            className="scroll"
            style={{ overflowY: "auto", height: "100%" }}
            anchor="right"
            open={isDrawerOpen}
            onClose={() => setIsDrawerOpen(false)}
            sx={{
              "& .MuiDrawer-paper": {
                width: "45%",
                overflow: "hidden",
                scrollbarWidth: "thin",
              },
            }}
          >
            <Box>
              <Divider />
              <InviteOrgDrawer
                onCloseDrawer={() => setIsDrawerOpen(false)}
                InviteTable={inviteTablerefetch}
              />
            </Box>
          </Drawer>
        </Box>
      )}
    </>
  );
};

export default Organisation;
